import { z } from 'zod';

export const ProfileTypeSchema = z.enum(['profile', 'use_case']);

export const UserProfileSchema = z.object({
  id: z.number(),
  title: z.string(),
  text: z.string(),
  type: ProfileTypeSchema,
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const UserProfileCreateSchema = z.object({
  title: z.string(),
  text: z.string(),
  type: ProfileTypeSchema.optional(),
  isActive: z.boolean().optional(),
});

export const UserProfileUpdateSchema = z.object({
  title: z.string().optional(),
  text: z.string().optional(),
  type: ProfileTypeSchema.optional(),
  isActive: z.boolean().optional(),
});
